import { pathOr } from 'ramda';

import { PRODUCT_NAMES } from '@/constants/treatment';
import {
  YOUR_ROUTINE_SUBSECTION_NAMES,
  YOUR_ROUTINE_PRODUCTS_PER_SUBSECTION_DEFAULT
} from '@/constants/your-routine';

import { COUNTRY_ISO } from '@/constants/countries';



const YOUR_ROUTINE_PRODUCTS_PER_SUBSECTION_WITH_NEXULTRA_1_2_3 = {
  ...YOUR_ROUTINE_PRODUCTS_PER_SUBSECTION_DEFAULT,
  [YOUR_ROUTINE_SUBSECTION_NAMES.MOISTURIZE]: [
    ...YOUR_ROUTINE_PRODUCTS_PER_SUBSECTION_DEFAULT[YOUR_ROUTINE_SUBSECTION_NAMES.MOISTURIZE],
    PRODUCT_NAMES.NEXULTRA_1,
    PRODUCT_NAMES.NEXULTRA_2,
    PRODUCT_NAMES.NEXULTRA_3
  ]
};

const COUNTRY_TO_ROUTINE_PRODUCT_NAMES_MAP = {
  [COUNTRY_ISO.SAUDI_ARABIA]: YOUR_ROUTINE_PRODUCTS_PER_SUBSECTION_WITH_NEXULTRA_1_2_3
};

const getRoutineProductNamesPerSubsectionByCountry = country =>
  pathOr(
    YOUR_ROUTINE_PRODUCTS_PER_SUBSECTION_DEFAULT,
    [country.toUpperCase()],
    COUNTRY_TO_ROUTINE_PRODUCT_NAMES_MAP
  );

export { getRoutineProductNamesPerSubsectionByCountry };
